/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HubIcon from '@mui/icons-material/Hub';
import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
import { StatCardV2 } from '../../../components/v2';
import {
  getStatusCount,
  sumFiltradoCounts,
  sumTotalCounts,
  SYNC_STATUS,
} from './constants';

const KPI_CONFIG = [
  {
    key: SYNC_STATUS.ERROR_SYNC,
    label: 'Erros',
    hint: 'Envio ao terceiro falhou. Clique para filtrar a tabela.',
    color: 'error',
    icon: <ErrorOutlineIcon />,
  },
  {
    key: 'TOTAL',
    label: 'No período',
    hint: 'Soma dos 3 status no filtro atual. Clique para ver todos os status.',
    color: 'primary',
    icon: <HubIcon />,
    isTotal: true,
  },
  {
    key: SYNC_STATUS.SYNCED,
    label: 'Sincronizados',
    hint: 'Terceiro aceitou. Clique para filtrar a tabela.',
    color: 'success',
    icon: <CheckCircleIcon />,
  },
  {
    key: SYNC_STATUS.NOT_SYNC,
    label: 'Pendentes de envio',
    hint: 'Ainda não enviado — diferente de erro. Clique para filtrar a tabela.',
    color: 'info',
    icon: <HourglassEmptyIcon />,
  },
];

const formatCardValue = (filtrado, total) => {
  if (filtrado == null && total == null) {
    return { value: null, valueFiltered: null, valueTotal: null };
  }
  const filteredCount = filtrado ?? 0;
  const totalCount = total ?? null;
  const showSplit = totalCount != null && totalCount !== filteredCount;
  return {
    value: filteredCount,
    valueFiltered: filteredCount,
    valueTotal: showSplit ? totalCount : null,
  };
};

const SparklineSlot = ({ data, color }) => {
  if (!data || !data.length) return null;
  return (
    <Box sx={{ mt: 1, height: 32, width: '100%' }}>
      <SparkLineChart
        data={data}
        height={32}
        colors={[color]}
        showHighlight={false}
        showTooltip={false}
      />
    </Box>
  );
};

SparklineSlot.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number),
  color: PropTypes.string,
};

SparklineSlot.defaultProps = {
  data: null,
  color: undefined,
};

const OverviewKpis = ({
  resumo,
  loading,
  activeStatus,
  onFilterByStatus,
  sparklineColors,
}) => {
  const { filtrado, total, sparklines } = resumo;

  return (
    <Grid container spacing={2}>
      {KPI_CONFIG.map((config) => {
        const isActive = config.isTotal
          ? activeStatus == null
          : activeStatus === config.key;

        let cardValues;
        if (config.isTotal) {
          cardValues = formatCardValue(
            sumFiltradoCounts(filtrado),
            sumTotalCounts(total),
          );
        } else {
          cardValues = formatCardValue(
            getStatusCount(filtrado, config.key),
            getStatusCount(total, config.key),
          );
        }

        const sparkData = config.isTotal
          ? null
          : sparklines?.[config.key];

        return (
          <Grid key={config.key} size={{ xs: 6, sm: 6, md: 3 }}>
            <StatCardV2
              label={config.label}
              value={cardValues.value}
              valueFiltered={cardValues.valueFiltered}
              valueTotal={cardValues.valueTotal}
              totalCaption="no histórico"
              hint={config.hint}
              valueFontSize="2rem"
              icon={config.icon}
              color={config.color}
              loading={loading}
              active={isActive}
              activeLabel={config.isTotal ? 'Todos os status' : undefined}
              onClick={() => {
                if (config.isTotal) {
                  onFilterByStatus(null);
                } else {
                  onFilterByStatus(activeStatus === config.key ? null : config.key);
                }
              }}
            />
            {!loading && sparkData?.length > 0 && (
              <SparklineSlot
                data={sparkData}
                color={sparklineColors?.[config.key]}
              />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

OverviewKpis.propTypes = {
  resumo: PropTypes.shape({
    filtrado: PropTypes.object,
    total: PropTypes.object,
    sparklines: PropTypes.object,
  }).isRequired,
  loading: PropTypes.bool,
  activeStatus: PropTypes.string,
  onFilterByStatus: PropTypes.func.isRequired,
  sparklineColors: PropTypes.object,
};

OverviewKpis.defaultProps = {
  loading: false,
  activeStatus: null,
  sparklineColors: null,
};

export default OverviewKpis;
